import {connect} from "react-redux";
import ApprovalDsmLead from "./ApprovalAction";
import {bindActionCreators} from "redux";
import {getLeadById, leadApprovalAction} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    leadById:state.Lead.leadById,
    leadApprovalResponse:state.Lead.leadApprovalResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLeadById,
            leadApprovalAction
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalDsmLead);
